import { Checkbox, Stack, Text} from '@chakra-ui/react';

const MiniSelector = ({tempWidget, setTempWidget}) => {

    const handleChange = (metricName, metricType) => {
            let newStatArray = [];
            newStatArray.push(metricName);
            
            let updatedWidgetObject = {...tempWidget};
            updatedWidgetObject['statistic'] = newStatArray;
            updatedWidgetObject['type'] = metricType;
            setTempWidget(updatedWidgetObject);
    }; 

    return (

        <Stack spacing={3} direction='column'>
        <Text as='b'>Current Metrics</Text>
            <Checkbox
                name='OLDEST_CONTACT_AGE'
                isChecked={tempWidget.statistic.includes('OLDEST_CONTACT_AGE')}
                onChange={(e) => handleChange('OLDEST_CONTACT_AGE', 'current')}
            >
                Oldest Contact Age
            </Checkbox>
            <Checkbox
                name='CONTACTS_IN_QUEUE'
                isChecked={tempWidget.statistic.includes('CONTACTS_IN_QUEUE')}
                onChange={(e) => handleChange('CONTACTS_IN_QUEUE', 'current')}
            >
                Contacts in Queue
            </Checkbox>
            
            <Text as='b'>Callback Metric</Text>
            <Checkbox
                name='CALLBACKS_WAITING'
                isChecked={tempWidget.statistic.includes('CALLBACKS_WAITING',)}
                onChange={(e) => handleChange('CALLBACKS_WAITING', 'callback')}
            >
                Callbacks Waiting
            </Checkbox>
            <Checkbox
                name='OLDEST_CALLBACK'
                isChecked={tempWidget.statistic.includes('OLDEST_CALLBACK')}
                onChange={(e) => handleChange('OLDEST_CALLBACK', 'callback')}
            >
                Oldest Callback
            </Checkbox>
            
            <Text as='b'>Historic Metrics</Text>
            <Checkbox
                name='CONTACTS_HANDLED'
                isChecked={tempWidget.statistic.includes('CONTACTS_HANDLED',)}
                onChange={(e) => handleChange('CONTACTS_HANDLED', 'historicalV2')}
            >
                Contacts Handled
            </Checkbox>
            <Checkbox
                name='CONTACTS_ABANDONED'
                isChecked={tempWidget.statistic.includes('CONTACTS_ABANDONED')}
                onChange={(e) => handleChange('CONTACTS_ABANDONED', 'historicalV2')}
            >
                Contacts Abandoned
            </Checkbox>
            <Checkbox
                name='CONTACTS_QUEUED'
                isChecked={tempWidget.statistic.includes('CONTACTS_QUEUED')}
                onChange={(e) => handleChange('CONTACTS_QUEUED', 'historicalV2')}
            >
                Contacts Queued
            </Checkbox>
            
             <Text as='b'>Cornerstone CX Metrics</Text>
            <Checkbox
                name='oldestItem'
                isChecked={tempWidget.statistic.includes('oldestItem',)}
                onChange={(e) => handleChange('oldestItem', 'CCX current')}
            >
                Oldest Item
            </Checkbox>
            <Checkbox
                name='itemsInQueue'
                isChecked={tempWidget.statistic.includes('itemsInQueue')}
                onChange={(e) => handleChange('itemsInQueue', 'CCX current')}
            >
                Items in Queue
            </Checkbox>
        </Stack>
    );
};

export default MiniSelector;